
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icon/Box Archive","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"data-name":"Masked Area","transform":"translate(-2081 -1782)","d":"M0 0h24v24H0z","stroke":"#707070","fill":"#fff"}})])]),_c('g',{attrs:{"data-name":"Icon/Box Archive","transform":"translate(2081 1782)","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 674","d":"M-2074.06-1761.435h10.131a2.912 2.912 0 002.127-.723 2.834 2.834 0 00.736-2.114v-9.816h-1.657v9.844a1.229 1.229 0 01-.324.918 1.259 1.259 0 01-.921.318h-10.065a1.259 1.259 0 01-.92-.318 1.229 1.229 0 01-.324-.918v-9.844h-1.658v9.816a2.831 2.831 0 00.736 2.119 2.936 2.936 0 002.139.718zm2.053-8.109h6.032a.68.68 0 00.5-.2.705.705 0 00.2-.521v-.295a.675.675 0 00-.7-.71h-6.032a.7.7 0 00-.512.195.687.687 0 00-.2.515v.295a.705.705 0 00.2.521.692.692 0 00.512.2zm-4.423-3.746h14.87a1.777 1.777 0 001.382-.531 2.034 2.034 0 00.484-1.423v-1.372a2.017 2.017 0 00-.485-1.422 1.785 1.785 0 00-1.381-.526h-14.87a1.814 1.814 0 00-1.369.526 1.961 1.961 0 00-.508 1.422v1.372a2.019 2.019 0 00.49 1.426 1.794 1.794 0 001.387.528zm.37-1.543a.64.64 0 01-.481-.153.681.681 0 01-.145-.481v-.921a.7.7 0 01.145-.49.639.639 0 01.481-.153h14.138a.623.623 0 01.472.153.7.7 0 01.144.49v.922a.682.682 0 01-.144.481.625.625 0 01-.472.153z","fill":"#fff"}})])])
          )
        }
      }
    